import { DEFAULT_DATE_FORMAT } from '@openx/constants/date';
import type {
  DealInsightsFilterOptions,
  DealInsightsFilterOptionsApi,
  DealInsightsFilterOptionsParamsApi,
} from '@openx/types/dealInsights';
import { dealInsightsFilterOptionKeys } from '@openx/types/dealInsights';
import { format } from 'date-fns';
import type { UseDealInsightsFilterOptionsParam } from './context/DealHookTypes';

const defaultFilterOptions: DealInsightsFilterOptions = {
  [dealInsightsFilterOptionKeys.BUYER_NAME]: [],
  [dealInsightsFilterOptionKeys.DSP_NAME]: [],
  [dealInsightsFilterOptionKeys.PUB_NAME]: [],
  [dealInsightsFilterOptionKeys.TYPE_NAME]: [],
  [dealInsightsFilterOptionKeys.DOMAIN_BUNDLE]: [],
  [dealInsightsFilterOptionKeys.MEDIA_SUBTYPE]: [],
  [dealInsightsFilterOptionKeys.DEAL]: [],
  [dealInsightsFilterOptionKeys.CHANNEL]: [],
  [dealInsightsFilterOptionKeys.ADSIZE]: [],
  [dealInsightsFilterOptionKeys.AD_DURATION]: [],
};

export const filtersToApiParams = (param: UseDealInsightsFilterOptionsParam): DealInsightsFilterOptionsParamsApi => {
  return {
    start_date: format(param.startDate, DEFAULT_DATE_FORMAT),
    end_date: format(param.endDate, DEFAULT_DATE_FORMAT),
    account: param.account,
    ox_deal_id: param.deal.map(deal => deal.ox_deal_id),
    buyer_name: param.buyerName.map(buyer => buyer.name),
    dsp_name: param.dspName.map(dsp => dsp.name),
    pub_name: param.pubName.map(pub => pub.name),
    type_name: param.typeName.map(type => type.name),
    domain_bundle: param.domainBundle.map(domain => domain.name),
    media_subtype: param.mediaSubtype.map(media => media.name),
    channel: param.channel.map(channel => channel.name),
    adsize: param.adsize.map(adsize => adsize.name),
    ad_duration: param.adDuration.map(adDuration => adDuration.name),
  };
};

export const filtersFromApiResponse = (response?: DealInsightsFilterOptionsApi): DealInsightsFilterOptions => {
  if (!response) {
    return defaultFilterOptions;
  }
  return {
    [dealInsightsFilterOptionKeys.DEAL]: response.deal,
    [dealInsightsFilterOptionKeys.BUYER_NAME]: response.buyer_name,
    [dealInsightsFilterOptionKeys.DSP_NAME]: response.dsp_name,
    [dealInsightsFilterOptionKeys.PUB_NAME]: response.pub_name,
    [dealInsightsFilterOptionKeys.TYPE_NAME]: response.type_name,
    [dealInsightsFilterOptionKeys.DOMAIN_BUNDLE]: response.domain_bundle,
    [dealInsightsFilterOptionKeys.MEDIA_SUBTYPE]: response.media_subtype,
    [dealInsightsFilterOptionKeys.CHANNEL]: response.channel,
    [dealInsightsFilterOptionKeys.ADSIZE]: response.adsize,
    [dealInsightsFilterOptionKeys.AD_DURATION]: response.ad_duration,
  };
};
